import { useState } from "react";

const faqs = [
  {
    q: "爆瓜爆料社的内容是从哪里来的？",
    a: "内容主要来自公开报道、平台公开动态与热心网友的投稿线索。编辑会对线索做基础核对，涉及当事人未证实的部分，我们会在正文中明确标注为传闻或未经证实。",
  },
  {
    q: "为什么有些爆料没有给出结论？",
    a: "很多事件在传播初期信息并不完整，过早下结论容易误伤。我们更倾向于把已知信息、各方说法和时间线整理清楚，把判断权交回给读者。",
  },
  {
    q: "可以匿名投稿吗？",
    a: "可以。投稿时不需要填写真实姓名，我们在核实过程中也会对来源信息严格保密。如果线索涉及具体证据，建议在投稿表单里留下可联系的邮箱，方便编辑跟进。",
  },
  {
    q: "发现内容有误怎么反馈？",
    a: "通过联系页面的表单提交指正说明，附上相关链接或截图。核实后我们会在 24 小时内更正或下架相关内容，并在文末标注修改说明。",
  },
  {
    q: "网站会接广告或者带货吗？",
    a: "目前站内以内容聚合为主，不做带货。未来如涉及商业合作，会在页面显著位置进行标注，并保持编辑判断与商务合作相互独立。",
  },
];

export default function Faq() {
  const [open, setOpen] = useState<number | null>(0);

  return (
    <div className="flex flex-col gap-3">
      {faqs.map((item, idx) => {
        const isOpen = open === idx;
        return (
          <div
            key={item.q}
            className="overflow-hidden rounded-lg border border-background-200/80 bg-background-50"
          >
            <button
              type="button"
              onClick={() => setOpen(isOpen ? null : idx)}
              className="flex w-full cursor-pointer items-center justify-between gap-4 px-5 py-4 text-left"
            >
              <h3 className="font-heading text-base font-bold text-foreground-900">{item.q}</h3>
              <i
                className={`shrink-0 text-lg text-primary-500 transition-transform ${
                  isOpen ? "ri-subtract-line" : "ri-add-line"
                }`}
                aria-hidden="true"
              />
            </button>
            {isOpen && (
              <p className="border-t border-background-100 px-5 py-4 text-sm leading-7 text-foreground-600">
                {item.a}
              </p>
            )}
          </div>
        );
      })}
    </div>
  );
}